import { Box } from '@repo/ui/Box';

import type { TaskComponentType } from '../../../workflow/schemaTypes';
import { SubmittedRequests } from './SubmittedRequests';
import { IneligibleItems } from './IneligibleItems';
import { EligibleItems } from './EligibleItems';
import s from './ItemSelectionTask.module.css';

export const ItemSelectionTask: TaskComponentType = ({ handleNext }) => {
  return (
    <Box isContainer className={s.itemSelectionContainer}>
      <EligibleItems handleNext={handleNext} />
      <SubmittedRequests />
      <IneligibleItems />
    </Box>
  );
};
